"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XRMRecaptchaActions = void 0;
var XRMRecaptchaActions;
(function (XRMRecaptchaActions) {
    XRMRecaptchaActions["SubmitClient"] = "XRL_SUBMIT_CLIENT";
    XRMRecaptchaActions["SubmitProspect"] = "XRL_SUBMIT_PROSPECT";
    XRMRecaptchaActions["ValidateClient"] = "XRL_VALIDATE_ClIENT";
    XRMRecaptchaActions["ValidateProspect"] = "XRL_VALIDATE_PROSPECT";
})(XRMRecaptchaActions || (exports.XRMRecaptchaActions = XRMRecaptchaActions = {}));
